import { unpackToTime } from '@campfire/hot-date';
import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { StringParam, useQueryParams } from 'use-query-params';
import {
  Loop as LoopIcon,
  EventNote as EventNoteIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
} from '@material-ui/icons';
import { ActivityCard } from '../../../../common/cards/activity-card/ActivityCard';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';

interface Props {
  activity: any;
  selected?: boolean;
  availabilityCenterItem?: boolean;
}

export const ActivityItem = (props: Props) => {
  const { theme } = useCampfireTheme();
  const { activity, selected, availabilityCenterItem } = props;

  const [query] = useQueryParams({
    activityId: StringParam,
  });

  const isSelected = (queryParams: any) => {
    if (availabilityCenterItem) {
      return selected;
    }
    return queryParams.activityId === activity.activityId || selected;
  };

  const activityStartTime = unpackToTime(activity.startTime).toFormat('h:mm a');
  const activityEndTime = unpackToTime(activity.endTime).toFormat('h:mm a');
  const isSelfDirected = (activity as any).activityType === 'self_directed';
  const { isEvent } = activity as any;
  const recurrenceHumanReadable =
    activity.__typename === 'VOLUNTEER_RecurringActivityType'
      ? activity.schedule.recurrences[0].humanReadable
      : isSelfDirected
      ? 'Self-Directed'
      : isEvent
      ? 'Event'
      : 'Flexible';
  const TypeIcon = isSelfDirected ? AssignmentTurnedInIcon : isEvent ? EventNoteIcon : LoopIcon;

  return (
    <Box>
      <ActivityCard
        activity={activity}
        color={isSelected(query) ? theme.color.activities.status.primary : theme.color.activities.status.default}
        selected={isSelected(query)}
      >
        <Typography
          variant={'caption'}
          style={{ color: theme.color.grey.neutral200, display: 'flex', alignItems: 'center' }}
        >
          {recurrenceHumanReadable && <TypeIcon style={{ width: '0.7em', height: '0.7em', paddingRight: '4px' }} />}
          {recurrenceHumanReadable}
          {!isEvent && !isSelfDirected && activity.startTime && activity.endTime
            ? `, ${activityStartTime} - ${activityEndTime}`
            : ''}
        </Typography>
      </ActivityCard>
    </Box>
  );
};
